import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const ReconsiderationApprovalAgreement = () => {
  const fileStatus = 33;
  const applicationPath = {
    copyright: "/admin/reconsideration-approval-copyright",
    agreement: "/admin/reconsideration-approval-agreement",
  };
  return (
    <SubmittedAgreement
      pageTitle={"অনুমোদন পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-agreement-details"}
    />
  );
};

export default ReconsiderationApprovalAgreement;
